global.conmed = global.conmed || {};

conmed.linkPopup = function ($) {
    'use strict';
    var that = {

    };

    that.init = function () {
        const popup = document.getElementById('linkPopup');

        $('.external').click(function (e) {
            e.preventDefault();

            $('#linkPopup').modal('show');

            var el = $(this).attr('href');

            $('.elm-ok').data('source', el);

        });

        $('.elm-ok').click(function () {
            window.location = $(this).data('source');
        });
    };

    return that;
}(jQuery);